import { useState as r } from "react";
import t from "jsonp";
import e from "query-string";

function n() {
  return (n = Object.assign || function (r) {
    for (var t = 1; t < arguments.length; t++) {
      var e = arguments[t];

      for (var n in e) {
        Object.prototype.hasOwnProperty.call(e, n) && (r[n] = e[n]);
      }
    }

    return r;
  }).apply(this, arguments);
}

var s = function s(_s) {
  var o = {
    loading: !1,
    error: !1,
    success: !1
  },
      a = r(o),
      i = a[0],
      c = a[1],
      u = r(""),
      p = u[1];
  return {
    status: i,
    message: u[0],
    handleSubmit: function handleSubmit(r, a) {
      r.preventDefault();
      var u = e.stringify(a),
          f = _s.replace("/post?", "/post-json?") + "&" + u;
      c(n({}, i, {
        loading: !0
      })), p("sending"), t(f, {
        param: "c"
      }, function (r, t) {
        r ? (c(n({}, o, {
          error: !0
        })), p(r)) : "success" !== t.result ? (c(n({}, o, {
          error: !0
        })), p(t.msg)) : (c(n({}, o, {
          success: !0
        })), p(t.msg));
      });
    },
    resetStatus: function resetStatus() {
      c(o);
    }
  };
};

export { s as useMailChimpForm };